@if (loading) {
  <div class="loading-spinner text-primary" role="status">
    <i class="fa-duotone fa-spinner-third fa-3x"></i>
  </div>
}